//
// Demo Manager
//

(function () {
  createDemoManager = function (json) {
    /*var*/ demoManager = new DemoManager();
    demoManager.data.container.manager = demoManager;
    demoManager.data.container.enableButton = demoManager.enableButton;
    demoManager.data.container.clearSelectedDemo = demoManager.clearSelectedDemo;
    return demoManager.data.container;
  };

  initDemoManager = function (json) {
    //	demoManObj.initialise(json);
    //	var demomanObj = resourceManager.get(json.FQN);
    demoManager.initialise(json);
  };

  getDemoManagerFilesRequired = function (json) {
    return [];
  };

  var invoker = function (obj, funcName) {
    return function (param1, param2) {
      obj[funcName](param1, param2);
    };
  };

  createButton = function (x, y, width, height, text, colour, fontDefinition) {
    var button = new PIXI.Graphics();

    button.lineStyle(1, 0, 1);
    button.beginFill(colour, 1);

    button.buttonWidth = width;
    button.buttonHeight = height;
    button.buttonColour = colour;

    button.drawRect(
      x / resourceManager.selectedAssetResolution.scaleFactor,
      y / resourceManager.selectedAssetResolution.scaleFactor,
      width / resourceManager.selectedAssetResolution.scaleFactor,
      height / resourceManager.selectedAssetResolution.scaleFactor
    );
    button.endFill();
    button.interactive = true;
    button.visible = true;
    var text = resourceManager.createObject('text', 'buttonText_' + text, 'demoManager', {
      text: text,
      x: x + width / 2,
      y: y + height / 2,
      fontDefinition: fontDefinition,
      maxWidth: width,
    });
    text.anchor.set(0.5);
    button.addChild(text);
    return button;
  };

  Demo = function (demo, selectedCallback) {
    this.data = [];

    this.data.demo = demo;
    this.data.selectedCallback = selectedCallback;
  };

  Demo.prototype.createButton = function (x, y, width, height, fontDefinition) {
    this.data.button = createButton(x, y, width, height, this.data.demo.name, 0xff0000, fontDefinition);
    this.data.button.mousedown = this.data.button.touchstart = invoker(this, 'selected');
    this.data.button.visible = false;

    return this.data.button;
  };

  Demo.prototype.selected = function () {
    this.data.selectedCallback();
    //lifegame.platform.factory.requestService("event").gameForces(JSON.parse(JSON.stringify(this.data.demo.spins)));
    gdk.gameForces(JSON.parse(JSON.stringify(this.data.demo.spins)));
  };

  DemoManager = function () {
    this.data = {};

    this.data.rowsMax = 5;
    this.data.buttonWidth = 200;
    this.data.buttonHeight = 100;
    this.data.fontDefinition = 'small';
    this.data.container = new PIXI.Container();
  };

  DemoManager.prototype.initialise = function (json) {
    // disable if not stanalone release
    if (!gdk.hasForceOptions()) {
      return;
    }

    if (checkForDefined(json.buttonWidth)) this.data.buttonWidth = json.buttonWidth;
    if (checkForDefined(json.buttonHeight)) this.data.buttonHeight = json.buttonHeight;
    if (checkForDefined(json.fontDefinition)) this.data.fontDefinition = json.fontDefinition;
    if (checkForDefined(json.rows)) this.data.rowsMax = json.rows;

    var self = this;
    messageBus.subscribe('common:ReadyToStart', function () {
      self.show(true);
    });

    messageBus.subscribe('common:GameCommitted', function () {
      self.closeMenu();
      self.show(false);
    });

    this.data.demos = [];
    this.data.demoButtons = {};

    var i, j, k;
    for (i = 0; i < json.demos.length; ++i) {
      this.data.demos.push(new Demo(json.demos[i], invoker(this, 'demoSelected')));
    }

    this.data.demoButton = createButton(
      0,
      0,
      this.data.buttonWidth,
      this.data.buttonHeight,
      'DEMO',
      0xff0000,
      this.data.fontDefinition
    );
    this.data.demoButton.mousedown = this.data.demoButton.touchstart = invoker(this, 'demoButtonPressed');
    this.data.container.addChild(this.data.demoButton);

    this.createDemoButtons();
  };

  DemoManager.prototype.createDemoButtons = function () {
    var i;
    for (i = 0; i < this.data.demos.length; ++i) {
      this.createDemoButton(i, this.data.demos[i]);
    }
  };

  DemoManager.prototype.createDemoButton = function (index, demo) {
    var row = index % this.data.rowsMax;
    var col = Math.floor(index / this.data.rowsMax);
    var x = col * (this.data.buttonWidth + 5);
    var y = row * (this.data.buttonHeight + 5);

    var button = demo.createButton(x, y, this.data.buttonWidth, this.data.buttonHeight, this.data.fontDefinition);
    button.row = row;
    button.col = col;
    this.data.demoButtons[demo.data.demo.name] = button;

    this.data.container.addChild(demo.data.button);
  };

  DemoManager.prototype.openMenu = function (open) {
    open = open === undefined ? true : open;
    this.data.demoButton.visible = !open;
    var i;
    for (i = 0; i < this.data.demos.length; ++i) {
      this.data.demos[i].data.button.visible = open;
    }
  };

  DemoManager.prototype.closeMenu = function () {
    this.openMenu(false);
  };

  DemoManager.prototype.demoButtonPressed = function () {
    this.openMenu();
  };

  DemoManager.prototype.demoSelected = function () {
    this.openMenu(false);
  };

  DemoManager.prototype.show = function (show) {
    show = show === undefined ? true : show;
    resourceManager.getContainer('DemoContainer').visible = show;
  };

  DemoManager.prototype.clearSelectedDemo = function () {
    gdk.gameForces({ name: 'Clear', spins: [] });
  };

  DemoManager.prototype.enableButton = function (name, enabled) {
    if (checkForUndefined(this.manager.data.demoButtons[name])) {
      console.log("Demo button '" + name + "' does not exist");
      return;
    }

    var button = this.manager.data.demoButtons[name];
    var x = button.col * (this.manager.data.buttonWidth + 5);
    var y = button.row * (this.manager.data.buttonHeight + 5);

    button.interactive = enabled;
    button.clear();
    button.lineStyle(1, 0, 1);
    button.beginFill(button.buttonColour, enabled ? 1 : 0.6);
    button.drawRect(
      x,
      y,
      button.buttonWidth / resourceManager.selectedAssetResolution.scaleFactor,
      button.buttonHeight / resourceManager.selectedAssetResolution.scaleFactor
    );
    button.endFill();
    button.children[0].alpha = enabled ? 1.0 : 0.7;
  };

  resourceManager.registerObjectType('demoManager', createDemoManager, initDemoManager, getDemoManagerFilesRequired);
})();
